// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__32Lc8","inner":"Footer_inner__2wnI5","nextIcon":"Footer_nextIcon__2mZpW","innerLeft":"Footer_innerLeft__2vVOu"};